<template>
    <div>
        <div class="layout">
            <div class="cabinet-page_bg"></div>

            <HeaderAuth/>
            <div class="cabinet-content-block-wrapper">
                <div class="cabinet-content-block">

                    <AdminNavigation/>
                    <div class="cabinet-content">
                        <div class="heading-wrapper">
                            <div class="title">
                                <router-link :to="returnPage" class="button-close">
                                    <BackIcon/>
                                </router-link>
                                <div class="text">{{ client.surname }} {{ client.name }} {{ client.patronymic }}</div>
                            </div>
                            <div class="client-status" :class="getClassName(client.status)">
                                {{ $ml.with('VueJS').get(client.status) }}
                            </div>
                        </div>
                        <div class="cabinet-content-inner">
                            <div class="tabs-big tabs">

                                <div class="tabs-caption">
                                    <div class="tabs-caption-inner">
                                        <div class="item active">Проверка клиента</div>
                                        <div class="item">Личные данные</div>
                                        <div class="item">Данные контактных лиц</div>
                                    </div>
                                </div>

                                <div class="tabs-content active">
                                    <ClientCheck :steps-initial="stepsData" :current-step-initial="currentStep" :addressee-list="client.addresseeList" @statusChanged="statusChanged"/>
                                </div>

                                <div class="tabs-content">
                                    <ClientPersonal :client="client"/>
                                </div>

                                <div class="tabs-content">
                                    <ClientContacts :addreeseeList="client.addresseeList"/>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <FooterAuth/>
    </div>
</template>

<script>
import FooterAuth from "../../components/FooterAuth";
import HeaderAuth from "../../components/HeaderAuth";
import AdminNavigation from "../../components/AdminNavigation";
import BackIcon from "@/components/icons/BackIcon";
import ClientCheck from "@/components/blocks/ClientCheck";
import ClientPersonal from "@/components/blocks/ClientPersonal";
import ClientContacts from "@/components/blocks/ClientContacts";
import rest from "../../restUtils";

export default {
    name: "ClientPage",
    components: {ClientContacts, ClientPersonal, ClientCheck, BackIcon, AdminNavigation, HeaderAuth, FooterAuth},
    metaInfo: {
        title: 'Клиенты | Your Last Word'
    },

    data() {
        return {
            currentTab: 'check',
            client: {
                status: 'waitVerification'
            },
            stepsData: {
                firstStep: [],
                secondStep: [],
                thirdStep: []
            },
            currentStep: 1,
            returnPage: 'clients'
        }
    },

    mounted() {
        $('.tabs-caption').on('click', '.item:not(.active)', function () {
            $(this)
                .addClass('active').siblings().removeClass('active')
                .closest('.tabs').find('.tabs-content').hide().eq($(this).index()).fadeIn(400);
        });
    },

    beforeCreate() {
        $('body').attr('class', 'cabinet-page');
        $('body').addClass('clients-item-page');
    },


    async created() {
        if (this.$route.query.return) {
            this.returnPage = this.$route.query.return;
        }
        this.client = await rest.doGet("/admin/client/" + this.$route.query.id);
        this.stepsData = {
            firstStep: this.client.steps.filter(step => step.stepNumber === 1),
            secondStep: this.client.steps.filter(step => step.stepNumber === 2),
            thirdStep: this.client.steps.filter(step => step.stepNumber === 3)
        };
        this.currentStep = this.client.currentStep;
        if (this.client.patronymic === null) {
            this.client.patronymic = '';
        }

        let socialToken = this.$route.query.socialToken;
        if (!!socialToken) {
            let query = Object.assign({}, this.$route.query);
            delete query.socialToken;
            this.$router.replace({query});
            await this.$store.dispatch('changeLanguage', this.$ml.current);
        }

    },

    methods: {
        getClassName(statusCode) {
            switch (statusCode) {
                case "subscribed":
                    return "status__payed";
                case "waitVerification":
                    return "status__check";
                case "waitSend":
                    return "status__wait";
                case "mailsSent":
                    return "status__send";
                default:
                    return "status__free";
            }
        },
        statusChanged(status) {
            this.client.status = status;
        }
    }
}
</script>

<style>
.vue-tel-input.disabled .vti__dropdown .vti__dropdown-arrow {
    opacity: 0 !important;
}

.vue-tel-input.disabled .vti__dropdown {
    cursor: default !important;
    outline: 0 !important;
    background-color: rgba(0, 0, 0, 0.05) !important;
}

.vue-tel-input.disabled input {
    cursor: default !important;
}

.vue-tel-input.disabled:focus-within {
    box-shadow: none !important;
    border-color: #bbb !important;
}
</style>